import Loading from '@/pages/extra/loading.vue';
import { RouteConfig } from 'vue-router';
import { ROUTE_NAME } from './constant';

export const routes: RouteConfig[] = [
    {
        path: '/game/rank/:activityId',
        name: ROUTE_NAME.GAME_RANK,
        meta: {
            title: '百日竞技场',
            needBinding: true,
            needLoginNext: true,
        },
        component: () => import(/* webpackChunkName: "game" */ './pages/rank.vue'),
    },
];
